import { withRouter } from 'react-router'
import Page_video from '../../components/Video/Page_video'
import { connect } from 'react-redux'
import { compose } from 'react-apollo'
import {graphql} from "react-apollo/index";
import { channels } from "../../graphqlDic";

export default compose(
    graphql(channels,{
        name:'channels'
    })
)(withRouter(
    connect(
        null,
        null
    )(Page_video)
));



// WEBPACK FOOTER //
// ./src/containers/Video/ListVideo.js